import * as form from '../form';

export const substanceDrugSupplementalUsage = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        DateRange: form.daterange(xitem.DateRange),
        NumberOfTimesUsed: form.text(xitem.NumberOfTimesUsed),
        DrugUsed: form.radio(xitem.DrugUsed),
        Comment: form.text(xitem.Comment)
      },
    };
  });
  return {
    IllegalControlledSubstanceUseAnswer: form.branch(data.IllegalControlledSubstanceUseAnswer),
    IllegalControlledSubstanceUseComment: form.textarea(data.IllegalControlledSubstanceUseComment),
    IllegalControlledSubstanceUseSummaryComment: form.textarea(data.IllegalControlledSubstanceUseSummaryComment),
    List: form.collection(items, (data.List || {}).branch),
  };
};
